'use strict';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/takeUntil';
import {stateGoBack, stateGoEnter, stateGoForward} from '../../app/actions';
import {assignAssetProjectToModel, assignAssetToModel} from '../../app/model/actions';
import {getAsset, getOrganization, getProject} from '../../app/model/reducers/state';
import {navStates} from '../../app/router';
import {SCOPE_DESTROY} from '../../config/constants/view-events';
import {
  supportsDownload,
  supportsImportExport,
} from '../../core-utilities-implementation/device-services/DeviceServicesCordova';
import {getId, getLink} from '../../core-utilities/domain/ReduxUtils';
import {eventToObservable} from '../../core-utilities/rx-utils';
import {SITE as TASK_TYPE_SITE} from '../../tasks/enums/TASK_TYPE';
import {projectTasksStates} from '../../tasks/router-config';
import {assetProjectListActions} from '../actions/assetListActions';
import {projectStates} from '../router-config';


ProjectsAssetProjectsListController.$inject = [
  '$log',
  '$scope',
  '$permissions',
  'rxPermissionsService',
  '$popup',
  '$ngRedux',
  '$modal',
  '$contextMenu',
  '$miscUtils',
  '$toast',
  '$translate',
  'FilesDownloadService',
  'ProjectImportExportService',
  'AssetDomain',
  'AssetProjectDomain',
  'parentStatusService',
  'timerExportService',
];

export function ProjectsAssetProjectsListController(
  $log,
  $scope,
  $permissions,
  rxPermissionsService,
  $popup,
  $ngRedux,
  $modal,
  $contextMenu,
  $miscUtils,
  $toast,
  $translate,
  FilesDownloadService,
  ProjectImportExportService,
  AssetDomain,
  AssetProjectDomain,
  parentStatusService,
  timerExportService,
) {
  const scopeDestroy$ = eventToObservable($scope, SCOPE_DESTROY);
  const vm = $scope.assetProjectsList = this;

  /* Bound context actions */
  const openProjectImportAction = $miscUtils.blockPromise(openProjectImport);
  const openProjectExportAction = $miscUtils.blockPromise(openProjectExport);
  const downloadProjectFilesAction = $miscUtils.blockPromise(downloadProjectFiles);

  $scope.$evalAsync(initList);

  // temp - bind action props:
  vm.listProps = {
    onClickOptions,
    onClickItem: (e, model) => goToAsset(model),
    onItemContextMenu: (e, model) => openItemContextMenu(model),
  };

  // end temp


  /*****************************************************************************************************************
   * Context Menu Actions
   ****************************************************************************************************************/

  function generate_TASKS_IMPORT(assetProject) {
    let permission = 'asset_project_tasks_import';
    if (parentStatusService.isAssetProjectLocked(assetProject))
      permission += '_locked';

    return {
      permission,
      action: {messageId: 'tasks.context.tasks.import.label', action: openProjectImportAction.bind({}, assetProject)},
    };
  }

  function generate_TASKS_EXPORT(assetProject) {
    return {
      permission: 'asset_project_tasks_view',
      action: {messageId: 'tasks.context.tasks.export.label', action: openProjectExportAction.bind({}, assetProject)},
    };
  }

  function generate_DOWNLOAD_ALL(assetProject) {
    return {
      permission: 'asset_task_fulfillments_view',
      action: {
        messageId: 'requirements.files.list.context.download.all.label',
        action: downloadProjectFilesAction.bind({}, assetProject),
      },
    };
  }

  function generate_REMOVE_ASSET(assetProject) {
    return {
      permission: parentStatusService.isAssetProjectLocked(assetProject)
        ? 'project_assets_delete_locked'
        : 'project_assets_delete',
      action: {
        messageId: 'tasks.context.project.assets.remove.label',
        action: removeAsset.bind({}, assetProject),
        important: true,
      },
    };
  }

  const EXPORT_ASSET_DATA = {
    permission: 'project_assets_export',
    action: {
      messageId: 'tasks.context.assets.export.label',
      action: ProjectImportExportService.openProjectAssetsExport,
    },
  };

  function get_MANAGE_ASSETS() {
    return {
      permission: parentStatusService.isProjectLocked() ? 'project_assets_create_locked' : 'project_assets_create',
      action: {messageId: 'projects.home.context.assets.manage.label', action: manageAssets},
    };
  }

  function onClickOptions() {
    const rootState = $ngRedux.getState();
    const orgId = getId(getOrganization(rootState));
    const projectId = getId(getProject(rootState));
    if (!orgId || !projectId) return;

    const checkActions = [];
    $contextMenu.addActionByProject(checkActions, projectId, EXPORT_ASSET_DATA);

    timerExportService.buildContextAction(checkActions, () => {
      timerExportService.exportProject();
    });

    $contextMenu.addActionByProject(checkActions, projectId, get_MANAGE_ASSETS());

    $contextMenu.showByPermission({
      titleMessageId: 'icon.options.title',
      cancelMessageId: 'defaults.context.cancel.label',
      actions: checkActions,
    });
  }

  function manageAssets() {
    $ngRedux.dispatch(stateGoForward({state: projectStates.projectsManageAssets}));
  }

  // TODO: check user permissions
  function openItemContextMenu(assetProject) {
    const rootState = $ngRedux.getState();
    const orgId = getId(getOrganization(rootState));
    const projectId = getId(getProject(rootState));
    if (!orgId || !projectId) return;

    const checkActions = [];

    if (supportsImportExport()) {
      $contextMenu.addActionByProject(checkActions, projectId, generate_TASKS_IMPORT(assetProject));
      $contextMenu.addActionByProject(checkActions, projectId, generate_TASKS_EXPORT(assetProject));
    }

    if (supportsDownload()) {
      $contextMenu.addActionByProject(checkActions, projectId, generate_DOWNLOAD_ALL(assetProject));
    }

    if (!parentStatusService.isAssetProjectLocked(assetProject)) {
      $contextMenu.addActionByProject(checkActions, projectId, generate_REMOVE_ASSET(assetProject));
    }

    $contextMenu.showByPermission({
      titleMessageId: 'default.options.context.title.label',
      titleMessageParams: {name: getShortName(assetProject)},
      cancelMessageId: 'defaults.context.cancel.label',
      actions: checkActions,
    });
  }


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  let goToAsset__clicked = false;

  function goToAsset(model) {
    if (goToAsset__clicked)
      return;
    goToAsset__clicked = true;

    // TODO(redux): refactor this to no longer be necessary
    Promise
      .props({
        assetProject: AssetProjectDomain.$get(getId(model)),
        asset: AssetDomain.$get(getLink(model, 'asset').id),
      })
      .then(data => {
        // TODO(redux): convert to an Epic with an appropriate entrance action
        const rootState = $ngRedux.getState();
        const asset = getAsset(rootState);
        if (getId(data.asset) !== getId(asset)) {
          $ngRedux.dispatch(assignAssetToModel(data.asset));
          $ngRedux.dispatch(assignAssetProjectToModel(data.assetProject));
        }
        $ngRedux.dispatch(stateGoEnter({state: 'app.assets.tasks'}));
      })
      .finally(() => goToAsset__clicked = false);
  }

  function openProjectImport(assetProject) {
    if (assetProject) {
      return $modal.show({
        templateUrl: 'projects/project-import.html',
        controller: 'ProjectImportController',
        animation: 'slide-in-up',
        locals: {
          project: getId(assetProject),
          assetLevel: true,
          type: null,
        },
      });
    } else {
      // TODO: shouldn't happen. recover??
      $log.debug('TasksListController.openTaskImport: No project detected. Aborting.');
    }
  }

  /**
   * @param assetProject
   * @return {Promise<?String>}
   */
  function getFullName(assetProject) {
    if (assetProject) {
      return assetProject.$class ? assetProject.getFullName() : Promise.resolve(assetProject.name);
    } else {
      return Promise.resolve(null);
    }
  }

  /**
   * @param assetProject
   * @return {?String}
   */
  function getShortName(assetProject) {
    if (assetProject) {
      return assetProject.$class ? assetProject.toString() : assetProject.shortName;
    } else {
      return null;
    }
  }

  function openProjectExport(assetProject) {
    if (assetProject) {
      return getFullName(assetProject).then(projectName =>
        $modal.show({
          templateUrl: 'projects/project-export.html',
          controller: 'ProjectExportController',
          animation: 'slide-in-up',
          locals: {
            project: getId(assetProject),
            projectName: projectName,
            assetLevel: true,
            type: 'asset',
          },
        })
      );
    } else {
      // TODO: shouldn't happen. recover??
      $log.debug('TasksListController.openTaskExport: No project detected. Aborting.');
    }
  }

  function downloadProjectFiles(assetProject) {
    if (!assetProject) return;
    return getFullName(assetProject)
      .then(projectName => FilesDownloadService.downloadProjectFiles(getId(assetProject), projectName, TASK_TYPE_SITE));
  }

  function removeAsset(assetProject) {
    if (assetProject) {
      const id = getId(assetProject);
      const label = getShortName(assetProject);
      // TODO(i18n): translate confirmation
      // TODO(i18n): translate task delete confirmation
      return $popup
        .textInputConfirm({
          title: 'Remove Asset',
          body: `Are you sure you want to remove<br/>${label}<br/>Please enter<br/>REMOVE<br/>and press OK to continue`,
          confirmText: 'REMOVE',
        })
        .then(result => !result ? void 0 : $ngRedux.dispatch(assetProjectListActions.deleteItem({id, label})));
    }
  }


  /*****************************************************************************************************************
   * Load Data
   ****************************************************************************************************************/

  // TODO: move to an epic
  function initList() {
    const projectId$ = $ngRedux.state$
      .map(state => getId(getProject(state)))
      .distinctUntilChanged()
      .takeUntil(scopeDestroy$);

    projectId$
      .filter(id => !!id)
      .switchMap((projectId) => $permissions.checkProjectPermission(projectId, 'project_assets_view'))
      .filter(hasPermission => !hasPermission)
      .subscribe(() => {
        $translate('projects.tabs.assets.list.title').then(name => {
          $toast.showI18nMessage({
            messageId: 'view.permission.denied.message',
            messageParams: {viewName: name},
            type: $toast.TOAST_TYPES.warning,
          });
        });

        // TODO: place this cascade navigation in a common service.
        const rootState = $ngRedux.getState();
        if (getProject(rootState)) {
          $ngRedux.dispatch(stateGoBack({state: projectTasksStates.tasks}));
        } else if (getOrganization(rootState)) {
          $ngRedux.dispatch(stateGoBack({state: navStates.projectsList}));
        } else {
          $ngRedux.dispatch(stateGoBack({state: navStates.orgsList}));
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/js/projects/controllers/ProjectsAssetProjectsListController.js